import { Box, makeStyles, styled } from "@material-ui/core";
import theme from "theme";
import { Body, H4 } from "components/design-system/atoms/Typography";
import { getFilterActivation } from "components/localOfferEligibility/LocalOfferEligibility";
import InformationDrawer from "../../design-system/molecules/InformationDrawer";
import CheckIcon from "components/localOffer/assets/checkCircleGreen.svg";
import LocalOfferDrawerContent from "components/localOffer/LocalOfferBlockDrawerContent";
import LeafWithBackground from "components/localOffer/assets/leafWithBackground.svg";
const BackgroundBox = styled(Box)({
  maxHeight: 450,
  maxWidth: 250,
  borderRadius: 8,
  backgroundColor: theme.palette.green,
  color: theme.palette.darkGreen,
});
const H4Title = styled(H4)({
  fontSize: 24,
  fontWeight: 700,
});
const SmallFontSizeBody = styled(Body)({
  fontSize: "16px",
});

const BENEFITS = ["Click & Collect gratuit", "Livraison 48h", "Soutient l'emploi local"];

export default function LocalSellingDrawer() {
  const classes = useStyle();
  if (getFilterActivation()) {
    return null;
  }
  return (
    <BackgroundBox px={2} py={3}>
      <Box mt={2} mb={3}>
        <H4Title>
          Achetez local, c&apos;est l&apos;idéal{" "}
          <Box component="span" paddingLeft="2px">
            <LeafWithBackground />
          </Box>
        </H4Title>
      </Box>
      <Box className={classes.items__container}>
        {BENEFITS.map((label) => {
          return (
            <Box className={classes.list__item} key={label}>
              <CheckIcon />
              <SmallFontSizeBody>{label}</SmallFontSizeBody>
            </Box>
          );
        })}
        <Box>
          <InformationDrawer
            anchor="right"
            width="470px"
            title="Disponibles près de chez vous"
            button={
              <Body fontWeight={600} textAlign="left" mt={3}>
                <u>En savoir +</u>
              </Body>
            }
          >
            {() => <LocalOfferDrawerContent />}
          </InformationDrawer>
        </Box>
      </Box>
    </BackgroundBox>
  );
}

const useStyle = makeStyles((theme) => ({
  items__container: {
    padding: 0,
  },
  list__item: {
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
    marginBottom: theme.spacing(2),
    "& svg": {
      marginRight: theme.spacing(1),
    },
  },
}));
